export const navLinks = [
  { id: "home", title: "Home" },
  { id: "about", title: "About" },
  { id: "menu", title: "Menu" },
  { id: "reservations", title: "Reservations" },
  { id: "order-online", title: "Order Online" },
  { id: "login", title: "Login" },
];
